import { styled } from '@arpeggi/ui'
import { useEffect, useState } from 'react'
// TODO: refactor icons to be imported from arpeggi ui
import { ArpeggiLogo } from '../../__legacy__/components/platform/icons'

const StyledLoaderContainer = styled('div', {
  position: 'absolute',
  top: '50%',

  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
})

const StyledLoaderBar = styled('div', {
  height: '8px',
  borderRadius: '4px',
  width: '150px',
  background: 'rgba(0,0,0,.1)',
  overflow: 'hidden'
})

const StyledLoaderProgress = styled('div', {
  height: '100%',
  maxWidth: '0%',
  width: '100%',
  transition: 'all 100ms ease',
  background: '$black'
})

const StyledArpeggiLogo = styled(ArpeggiLogo, {
  width: '32px',
  height: '32px',
  marginBottom: '24px'
})

const LoaderContainer = StyledLoaderContainer
const LoaderBar = StyledLoaderBar
const LoaderProgress = StyledLoaderProgress
const Logo = StyledArpeggiLogo

export const Loader = () => {
  const [progress, setProgress] = useState(0)
  useEffect(() => {
    // the smaller the step the slower the progress bar will move
    let step = 0.5
    let current_progress = 0
    const interval = setInterval(() => {
      current_progress += step
      setProgress(Math.round((Math.atan(current_progress) / (Math.PI / 2)) * 100 * 1000) / 1000)
      if (progress > 70) step = 0.1
    }, 100)
    return () => {
      clearInterval(interval)
    }
  }, [])
  return (
    <LoaderContainer>
      <Logo />
      <LoaderBar>
        <LoaderProgress style={{ maxWidth: progress + '%' }} />
      </LoaderBar>
    </LoaderContainer>
  )
}
